export default __webpack_public_path__ + "static/media/block-fruit.fc6ff273.svg";